import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import { api } from "../../utils/apiClient";
import LoadingShimmer from "../../utils/LoadingShimmer";
import GlobalFilter from "../../components/filters/GlobalFilter";
import { showDeleteConfirm } from "../../utils/deleteConfirm";
import { toast } from "react-toastify";
import EventViewModal from "../../components/modal/EventViewModal";
import { Icon } from "@iconify/react/dist/iconify.js";
import ReadingPlanTable from "../../components/tables/ReadingPlanTable";
import ReadingPlanViewModal from "../../components/modal/ReadingPlanViewModal";
import ChurchesTable from "../../components/tables/churchesTable";
import ChurchModal from "../../components/modal/churchModal";




let searchTimeout;

const Churches = () => {
      const [readingPlan, setReadingPlan] = useState([]);
      const [churches, setChurches] = useState([]);
      const [loading, setLoading] = useState(true);

      //pagination
      const [page, setPage] = useState(1);
      const [limit] = useState(10);
      const [totalPages, setTotalPages] = useState(1);
      const [totalEntries, setTotalEntries] = useState(0);
      //sort
      const [sort, setSort] = useState("created_at");
      const [order, setOrder] = useState("desc");
      //search
      const [search, setSearch] = useState("");
      const [debouncedSearch, setDebouncedSearch] = useState("");
      const [dateFilters, setDateFilters] = useState({ startDate: "", endDate: "" });
      const [selectedDates, setSelectedDates] = useState([]);
      const [mobileFilterOpen, setMobileFilterOpen] = useState(false);
      const navigate = useNavigate();
      const [viewModalOpen, setViewModalOpen] = useState(false);
      const [selectedReadingPlan, setSelectedReadingPlan] = useState(null);
      const [entriesPerPage, setEntriesPerPage] = useState(10);
      //const [activeTab, setActiveTab] = useState("new");

      const handleView = (readingPlan) => {
            setSelectedReadingPlan(readingPlan);
            setViewModalOpen(true);
      };

      useEffect(() => {
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
                  setDebouncedSearch(search);
                  setPage(1);
            }, 1000);
            return () => clearTimeout(searchTimeout);
      }, [search]);

      const fetchReadingPlan = async () => {
            // console.log("inside churhc fetch reading plan");
            try {
                  setLoading(true);

                  const response = await api.get("/churches", {
                        params: {
                              page,
                              per_page: entriesPerPage,
                              sort,
                              order,
                              search: debouncedSearch?.trim() || "",
                              //status: activeTab,
                              startDate: dateFilters.startDate || undefined,
                              endDate: dateFilters.endDate || undefined,
                        }
                  });

                  setChurches(response.data.data || []);
                  setTotalPages(response.data.total_pages || 1);
                  setTotalEntries(response.data.total_entries || 0);

            } catch (error) {
                  console.error("Error fetching readingPlan:", error);
            } finally {
                  setLoading(false);
            }
      };

      useEffect(() => {
            fetchReadingPlan();
      }, [page, entriesPerPage, sort, order, debouncedSearch, dateFilters]);


      const handleClearFilters = () => {
            setDateFilters({ startDate: "", endDate: "" }); // reset date filters
            setSelectedDates([]); // reset UI calendar selection
            setPage(1); // reset pagination
      };

      const formatLocalDate = (date) => {
            if (!date) return "";
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const day = date.getDate().toString().padStart(2, "0");
            return `${year}-${month}-${day}`;
      };

      const handleDateFilter = ({ startDate, endDate, rawDates, status }) => {

            setSelectedDates(rawDates);

            const formattedStart = formatLocalDate(startDate);
            const formattedEnd = formatLocalDate(endDate);

            //console.log("Formatted Start Date:", formattedStart);
            //console.log("Formatted End Date:", formattedEnd);

            setDateFilters({
                  startDate: formattedStart,
                  endDate: formattedEnd,
                  status: status ? status.value : null,
            });
            setPage(1); // reset page
      };



      return (
            <>
                  <div className="page-header-row">
                        {/* Breadcrumb */}
                        <Breadcrumb title="Churches" />
                        <div className="filter-wrapper">

                              <div className="d-flex align-items-center gap-3">
                                    {/* Refresh Icon */}
                                    <Icon
                                          icon="mdi:refresh"
                                          width="26"
                                          height="26"
                                          className={`ms-2 d-inline-flex d-md-none mobile-refresh-icon ${loading ? "spin" : ""}`}
                                          onClick={fetchReadingPlan}
                                    />
                              </div>
                        </div>

                  </div>

                  {loading ? (
                        < LoadingShimmer
                              columns={8}
                              rows={6}
                              avatarColumnIndex={2}
                              actionColumnIndex={7}
                        />
                  ) : (
                        <ChurchesTable
                              readingplan={churches}
                              page={page}
                              setPage={setPage}
                              totalPages={totalPages}
                              totalEntries={totalEntries}
                              sort={sort}
                              order={order}
                              setSort={setSort}
                              setOrder={setOrder}
                              search={search}
                              setSearch={setSearch}
                              onView={handleView}
                              fetchReadingPlan={fetchReadingPlan}
                              entriesPerPage={entriesPerPage}
                              setEntriesPerPage={setEntriesPerPage}
                        />
                  )}

                  <ChurchModal
                        open={viewModalOpen}
                        onClose={() => setViewModalOpen(false)}
                        data={selectedReadingPlan}
                        onStatusChange={fetchReadingPlan}
                  />
            </>
      );
};

export default Churches;
